import { apis } from '@doltech/core/lib/api/api.config';
import { IconArrowsPushDown } from '@doltech/icons/IconArrowsPushDown';
import { CmsBookReview } from '@doltech/types';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { Image, Space } from 'antd';
import * as React from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../../../../hooks/useDeviceQuery.hook';
import { Button } from '../../../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../../../colors-v2';
import { Typography } from '../../../../DesignSystemV2/Typography';
import { DotDivider } from '../../../../Divider/DotDivider';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

const Main = styled.div`
  background: ${colorsV2.gray5};
  width: 100%;
  display: grid;
  gap: 16px;
  padding: 12px;

  @media ${deviceBreakpoints.fromTablet} {
    padding: 0;
    grid-template-columns: 252px minmax(0, 1fr);
    gap: 24px;
  }

  .ant-image {
    width: 100%;
  }

  .book-review-info {
    display: grid;
    gap: 4px;
    @media ${deviceBreakpoints.fromTablet} {
      padding: 8px 0;
    }
  }
`;

interface BookReviewProps extends React.HTMLAttributes<HTMLDivElement> {
  data: CmsBookReview;
}

export const ConnectedBookReview = ({ id }: { id: string }) => {
  const { data: res, isLoading } = useQuery(['bookReview', id], () =>
    apis.cms.get<CmsBookReview>(apiPublicUrls.cms.BOOK_REVIEW_BY_ID, { id })
  );

  if (!res || isLoading) return <div />;

  return <BookReview data={res?.data} />;
};

export const BookReview = ({ data }: BookReviewProps) => {
  return (
    <Main className="book-review">
      <Image src={data?.thumbnail?.url} preview={false} alt="" placeholder loading="lazy" />

      <div className="book-review-info">
        <Typography.Text variant="regular/12" color="black80">
          <Space size={0}>
            <span>Book Review</span>
            <DotDivider />
            <span>{data?.skill}</span>
          </Space>
        </Typography.Text>
        <Typography.Text variant="semi-bold/20">{data.name}</Typography.Text>
        <Typography.Text variant="regular/14">Tác giả: {data.author}</Typography.Text>
        <Button.Link
          iconLeft={<IconArrowsPushDown />}
          style={{ color: colorsV2.blue100, marginTop: 12, justifySelf: 'start' }}
          onClick={() => {
            const win = window.open(s3ToCDN(data.file?.url), '_blank');
            win.focus();
          }}
        >
          <Typography.Text variant="semi-bold/14">Download</Typography.Text>
        </Button.Link>
      </div>
    </Main>
  );
};
